import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import 'typeface-roboto';
import Home from './containers/home'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Signin from './containers/signin';

const timeout = 10000;
const theme = createTheme({
  palette: {
    primary: {
      main: '#fc4a1a',
      mainGradient: 'linear-gradient(to right, #ff512f, #f09819)'
    },
    secondary: {
      main: '#4ABDAC'
    },
    filter: {
      main: '#d32f2f',
      secondary: '#666666'
    }
  },
  status: {
    danger: 'red',
  },
  components: {
    MuiToolbar: {
      styleOverrides: {
        regular: {
          minHeight: "32px",
          '@media (min-width: 600px)': {
            minHeight: "40px"
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "40px",
          
        },
        flexContainer: {
          
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        gutters: {
          paddingLeft: "10px",
          paddingRight: "10px"
        },
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            height: "48px",
            minHeight: "0px"
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            margin: "10px 0"
          }
        }
      }
    },
    MuiAccordionDetails:{
      styleOverrides: {
        root: {
          padding: "0px 25px 10px 20px",
          maxHeight: '100%'
        }
      }
    },
    MuiInputBase:{
      styleOverrides: {
        input:{
          fontSize: "13px", /*adjust the font size of text input fields (like the login) */
        }
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0,0,0,0.3)'
        }
      }
    },
    MuiTooltip:{
      styleOverrides: {
        tooltip:{
          fontSize:"12px", /*adjust the the tooltip that shows on some buttons (like the "siguiente" when is disabled) */
        }
      }
    }
  }
});

const client = "Universidad de Valparaíso"

/*
  <MetaTags>
        <meta name='viewport' content='width=device-width' />
      </MetaTags>
*/

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Signin timeout={timeout} theme={theme} client={client} />}/>
          <Route exact path="/home" element={<Home timeout={timeout} theme={theme}/>}/>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
